module.exports = __webpack_public_path__ + "static/media/play_button.7fe4b65d.svg";